import { ImageLoader } from "next/image";

const homenetImageLoader: ImageLoader = ({ src: homenetSrc, width }) => {
  return homenetSrc.replace(".com/", `.com/${width}x${width}/`);
};

export default homenetImageLoader;
